import { render } from "./TextGenerationVis.vue?vue&type=template&id=365926c4"
import script from "./TextGenerationVis.vue?vue&type=script&lang=js"
export * from "./TextGenerationVis.vue?vue&type=script&lang=js"

import "./TextGenerationVis.vue?vue&type=style&index=0&id=365926c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__